export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'IE',
  'merchantReturnLink': 'https://www.timberland.ie/en-ie/customer-care/returns',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
